import { useApiClient } from "../apiClients";
import { STAGES_ENDPOINTS } from "./endpoints";
import type { Stage } from "../../models/domain";

export type ListStagesParams = {
  program_id: string;
  code?: string;
  limit?: number;
  offset?: number;
  sort?: string;
};

export type CreateStagePayload = Omit<
  Stage,
  "id" | "created_at" | "updated_at"
>;

export type UpdateStagePayload = Partial<CreateStagePayload>;

export const useStagesApi = () => {
  const apiClient = useApiClient("embed");

  const listStages = (params: ListStagesParams) =>
    apiClient.get<Stage[]>(STAGES_ENDPOINTS.BASE, { params });

  const getStage = (stageId: string) =>
    apiClient.get<Stage>(STAGES_ENDPOINTS.DETAIL(stageId));

  const createStage = (payload: CreateStagePayload) =>
    apiClient.post<Stage>(STAGES_ENDPOINTS.BASE, payload);

  const updateStage = (stageId: string, payload: UpdateStagePayload) =>
    apiClient.put<Stage>(STAGES_ENDPOINTS.DETAIL(stageId), payload);

  const deleteStage = (stageId: string) =>
    apiClient.delete<void>(STAGES_ENDPOINTS.DETAIL(stageId));

  return { listStages, getStage, createStage, updateStage, deleteStage };
};
